import { useMemo } from 'react';
import { haversineDistance } from '../utils/haversine';
import type { GeoPosition } from '../services/geolocation.service';

// AIDEV-NOTE: Calcula proximidade do usuario ao cliente para habilitar check-in
// podeCheckin = true somente se distancia <= raio E accuracy <= 50m (GPS preciso)

export function useProximidadeCliente(
  userPosition: GeoPosition | null,
  clienteLat?: number,
  clienteLng?: number,
  raioMetros = 200
) {
  return useMemo(() => {
    if (!userPosition || clienteLat == null || clienteLng == null) {
      return { distancia: null, estaProximo: false, podeCheckin: false };
    }
    const distancia = haversineDistance(userPosition.lat, userPosition.lng, clienteLat, clienteLng);
    const estaProximo = distancia <= raioMetros;
    return {
      distancia: Math.round(distancia),
      estaProximo,
      podeCheckin: estaProximo && userPosition.accuracy <= 50
    };
  }, [userPosition, clienteLat, clienteLng, raioMetros]);
}
